import React from 'react'
import { useStaticLabels } from 'shared/hooks/use-static-labels'
import styled from 'styled-components'

import Text from '~/views/components/ui/Text'

const BillableAllottedContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export type BillableAllottedContentProps = {
  billableHours?: number | null
  allottedHours?: number | null
}

export default function BillableAllottedContent({
  billableHours,
  allottedHours,
}: BillableAllottedContentProps) {
  const [getCommonLabel] = useStaticLabels(['common'])
  if (!allottedHours) return null

  return (
    <BillableAllottedContentContainer data-component-name="billable-allotted-container">
      <Text data-component-name="billable-allotted-label">
        {getCommonLabel('billableLogged')} / {getCommonLabel('allottedHours')}
      </Text>

      <Text weight="bold" data-component-name="billable-allotted-value">
        {`${billableHours || 0} / ${allottedHours}`}
      </Text>
    </BillableAllottedContentContainer>
  )
}
